import script from "./RoomBoilerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomBoilerItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomBoilerItem.vue?vue&type=style&index=0&id=411edbee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411edbee"]])

export default __exports__